function getFileType(file) {
  let fileType,
    type = file.type;
  if (type.indexOf('image') === 0) {
    fileType = '1';
  } else if (type.indexOf('video') === 0) {
    fileType = '3';
  } else if (type.indexOf('audio') === 0) {
    fileType = '4';
  } else {
    fileType = '2';
  }

  return fileType;
}

export default {
  // 获取oss文件上传签名
  getOssRequest(file) {
    let fileType = getFileType(file);
    let fileSuffix = file.name.split('.').pop();
    
    // 如果有建议的文件名，从建议名称中提取后缀
    if (file._suggestedName) {
      const suggestedSuffix = file._suggestedName.split('.').pop();
      if (suggestedSuffix !== file._suggestedName) {
        // 确保提取到的是真正的后缀（不是整个文件名）
        fileSuffix = suggestedSuffix;
      }
    }
    
    return async function() {
      let ret = await app.http.ajax({
        method: 'post',
        url: '/cs-crm/common/getOssStsSign',
        params: {
          businessType: 'x3_other',
          fileName: file.name,
          fileSuffix: fileSuffix,
          fileType: fileType,
          terminal: 0,
        },
      });
      let stsParams = ret.data;
      return stsParams;
    };
  },
};
